var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-tabs",
    { staticClass: "sub-menu md-3", attrs: { "slider-color": "primary" } },
    [
      _c(
        "v-tab",
        {
          staticClass: "sub-menu-item",
          attrs: { to: "/settings/travel-service", exact: "" }
        },
        [
          _vm._v(
            " " + _vm._s(_vm.$t("settings.travelService.menu.acceptance")) + " "
          )
        ]
      ),
      _c(
        "v-tab",
        {
          staticClass: "sub-menu-item",
          attrs: { to: "/settings/travel-service/additional-parameters" }
        },
        [
          _vm._v(
            " " +
              _vm._s(
                _vm.$t("settings.travelService.menu.additionalParameters")
              ) +
              " "
          )
        ]
      ),
      _c(
        "v-tab",
        {
          staticClass: "sub-menu-item",
          attrs: { to: "/settings/travel-service/mail-subject" }
        },
        [
          _vm._v(
            " " +
              _vm._s(_vm.$t("settings.travelService.menu.mailSubject")) +
              " "
          )
        ]
      ),
      _c(
        "v-tab",
        {
          staticClass: "sub-menu-item",
          attrs: { to: "/settings/travel-service/additional-settings" }
        },
        [
          _vm._v(
            " " +
              _vm._s(_vm.$t("settings.travelService.menu.additionalSettings")) +
              " "
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }